import type { HelpWidgetSession } from '@wix/ambassador-helpwidget-v1-session/types';

import { WidgetSessionUpdatePayload } from '../../../types/domain';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';

const { clientTopology } = renderModel.get();

type UpdateWidgetSessionErrorResponse = {
  error?: {
    message: string;
  };
};

type UpdateWidgetSessionResponse = UpdateWidgetSessionErrorResponse & {
  helpWidgetSession: HelpWidgetSession;
};

export async function updateWidgetSession(
  payload: WidgetSessionUpdatePayload,
): Promise<HelpWidgetSession | null> {
  try {
    const { data } = await httpClient
      .getInstance()
      .put<UpdateWidgetSessionResponse>(clientTopology.widgetSessionUrl, payload);

    if (data.error) {
      throw new Error(data.error.message);
    }

    return data.helpWidgetSession;
  } catch (error) {
    const message = 'Failed to update widget session';
    logger.error({ error, message, callParams: payload });
    console.error(error);
    return null;
  }
}
